module.exports = __webpack_public_path__ + "img/web-img2.da7e6541.png";